module.exports = __webpack_public_path__ + "static/media/img2.a1cf24b0.jpg";